import React, { Component } from 'react'
import Config from '../Constants/index'

export default class CustomerLkp extends Component {

    constructor(props) {
        super(props);
        //this.add = this.add.bind(this);
        let id = 0;
        let isEdit = false;
        /* if (this.props.match.params.Id) {
            id = this.props.match.params.Id;
            isEdit = true;
        }*/

/* name="CustomerRef" onChange={this.onChange} value={this.state.CustomerRef} */

        //let buildingRef = this.props.match.params.buildingRef;
        this.state = {
            //TODO
            Id: id,
            isEdit: false, 
            Title: '', 
            Short: '', 
            isRedirectEquipment: false,
            CalibrationTypeRef: 1,
            CustomerRef:-1,
            CalibrationTypes  :[{Id:1,Title:"Pressure"}],
            messages: [], 
            customers: []
        };

        this.onChange = this.onChange.bind(this);
        this.fetchCustomers = this.fetchCustomers.bind(this);

    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        this.props.onChange(e);
    }

    componentDidMount() {
        this.fetchCustomers();
    }

    fetchCustomers() {
        this.setState({ loading: true });
        fetch(Config.API_URL + "Customer/GetCustomerList/?timestamp=" + new Date().getTime(),
            { headers: { token: window.localStorage.getItem("apiToken") } })
            .then(response => response.json())
            .then(json => {
                this.setState({ customers: json, loading: false });
                console.log(this.state.customers);
            });

    }


    render() {
        return (
            <select class="form-control" id="exampleSelect1" name={this.props.name} 
                onChange={this.onChange}
                >
                <option value={0}>---</option>
                {
                    this.state.customers.map(function(item){
                        return <option  value={item.id}>{item.name}</option>
                    })
                }
            </select>        
        )
    }
}
